export default __webpack_public_path__ + "static/media/news65.767b8833.jpg";